import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './core/app'
import scrollToSection from '../../modules/scroll-to-section'

const developerSearchInit = {
  init() {
    const appElements = document.querySelectorAll('.developer-search__app')
    Array.from(appElements).forEach(element => {
      const data = element.dataset
      createRoot(element).render(<App {...data} />)
      document.addEventListener('step-updated', () => {
        scrollToSection.scroll(element)
      })
    })
  },
}

export default developerSearchInit
